<template>
  <vs-row style="height: 100%; position:relative;">
    <vs-col vs-w="12">

      <div id="todo-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">

          <vs-sidebar class="items-no-padding" parent="#todo-app" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isSidebarActive">
              <todo-add-new></todo-add-new>
              <VuePerfectScrollbar class="todo-scroll-area" :settings="settings">
              <!-- <todo-filters @closeSidebar="toggleTodoSidebar"></todo-filters> -->
              </VuePerfectScrollbar>
          </vs-sidebar>

          <div :class="{'sidebar-spacer': clickNotClose}" class="app-fixed-height border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light app-fixed-height">
              <div class="flex items-center app-search-container border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light">

                  <!-- TOGGLE SIDEBAR BUTTON -->
                  <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleTodoSidebar(true)"></feather-icon>

                  <!-- SEARCH BAR -->
                  <!-- <vs-input size="large" icon-pack="feather" icon="icon-search" placeholder="Search..." v-model="searchQuery" class="vs-input-no-border vs-input-no-shdow-focus no-icon-border w-full" /> -->
              </div>

              <!-- TODO LIST -->
              <VuePerfectScrollbar class="todo-content-scroll-area" :settings="settings" ref="todoListPS">
                  <transition-group class="todo-list" name="list-enter-up" tag="ul" appear>
                      <li class="cursor-pointer todo_todo-item" v-for="(todoItem, index) in selected.todos" :key="String(todoFilter) + String(todoItem.id)" :style="[{transitionDelay: (index * 0.1) + 's'}]">
                          <todo-item :todoItemId="todoItem.id" @showDisplayPrompt="showDisplayPrompt($event)"></todo-item>
                      </li>
                  </transition-group>
              </VuePerfectScrollbar>
              <!-- /TODO LIST -->
          </div>

          <!-- EDIT TODO DIALOG -->
          <todo-edit :displayPrompt="displayPrompt" :todoItemId="todoIdToEdit" @hideDisplayPrompt="hidePrompt" v-if="displayPrompt"></todo-edit>
      </div>

<!-- this below is without sidebar, searchbar and filters -->

      <!-- <div class="vx-card form-card" ref="card">
        <div class="vx-card__header">
          <vs-row class="my-10" vs-type="flex">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
               <h4>Lista To do</h4>
              <todo-add-new></todo-add-new>
            </vs-col>
          </vs-row>
        </div>
        <div class="vx-card__body">

          <VuePerfectScrollbar class="todo-content-scroll-area" :settings="settings" ref="todoListPS">
           <transition-group class="todo-list" name="list-enter-up" tag="ul" appear>
               <li class="cursor-pointer todo_todo-item" v-for="(todoItem, index) in selected.todos" :key="String(todoFilter) + String(todoItem.id)" :style="[{transitionDelay: (index * 0.1) + 's'}]">
                   <todo-item :todoItemId="todoItem.id" @showDisplayPrompt="showDisplayPrompt($event)"></todo-item>
               </li>
           </transition-group>
         </VuePerfectScrollbar>

        </div>
      </div> -->
    </vs-col>
  </vs-row>
</template>

<script>
import TodoAddNew from "./TodoAddNew.vue"
import TodoItem from "./TodoItem.vue"
import TodoFilters from "./TodoFilters.vue"
import TodoEdit from "./TodoEdit.vue"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  data () {
    return {
      clickNotClose: true,
      displayPrompt: false,
      todoIdToEdit: 0,
      isSidebarActive: true,
      windowWidth: window.innerWidth,
      settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.30,
      },
    }
  },
  props: {
    selected: Object
  },
  mounted() {
    console.log(this.selected);
  },
  methods: {
    formatDate(date) {
      var options = { year: "numeric", month: "short", day: "numeric" }
      return date.toLocaleDateString("it-IT", options).split(' ').map( (e) => e.charAt(0).toUpperCase() + e.substring(1)).join(' ')
    },
    showDisplayPrompt(itemId) {
     this.todoIdToEdit = itemId;
     this.displayPrompt = true;
    },
    hidePrompt() {
       this.displayPrompt = false;
    },
    handleWindowResize(event) {
       this.windowWidth = event.currentTarget.innerWidth;
       this.setSidebarWidth();
    },
    setSidebarWidth() {
       if(this.windowWidth < 992) {
           this.isSidebarActive = this.clickNotClose = false;
       }else {
           this.isSidebarActive = this.clickNotClose = true;
       }
    },
    toggleTodoSidebar(value = false) {
       if(!value && this.clickNotClose) return
       this.isSidebarActive = value;
    },
  },
  components: {
      TodoAddNew,
      TodoItem,
      TodoFilters,
      TodoEdit,
      VuePerfectScrollbar
  },
}
</script>

<style lang="scss">
  @import "@/assets/scss/vuesax/apps/todo.scss";
</style>
